// extracted by mini-css-extract-plugin
export default {"backButton":"backButton__jIeeU2"};